<script lang="ts">
  import HtmlParser from './partial/HtmlParser.svelte';

  interface Props {
    value?: string;
    anchorTooltipLabel?: string;
    onclick?: (e: MouseEvent) => void;
  }

  let { value = '', anchorTooltipLabel = '', onclick }: Props = $props();
</script>

<div class="comp-msg-template">
  <div class="label">
    <HtmlParser {value} {anchorTooltipLabel} {onclick} />
  </div>
</div>

<style>
  /* Apply styles here */
</style>
